<!-- Chargement -->


<!-- Mode sans accès (non-admin CGV) -->
@if (isNoAccess) {
<div class="flex flex-column gap-3 p-3">
    <div class="flex align-items-center gap-3 p-3 border-round surface-100">
        <i class="fa-solid fa-lock text-4xl text-yellow-500"></i>
        <div>
            <p class="m-0 font-semibold">Acceptation requise</p>
            <p class="m-0 text-color-secondary mt-1">
                Les {{ documentTypeLabel }} n'ont pas encore été acceptées pour ce dossier.
                Veuillez contacter votre administrateur pour les faire accepter.
            </p>
        </div>
    </div>
    <div class="flex justify-content-end">
        <p-button label="Fermer" severity="secondary" [rounded]="true" (onClick)="dismiss()"></p-button>
    </div>
</div>
}

<!-- Mode normal : affichage du document -->
@if (!isNoAccess) {
<div class="flex flex-column gap-3">

    @if (loading) {
    <div class="flex justify-content-center align-items-center p-5">
        <p-progressSpinner></p-progressSpinner>
    </div>
    } @else {
    @if (!document) {
    <p class="text-color-secondary">Aucun document disponible pour le moment.</p>
    } @else {
    <!-- Métadonnées -->
    <div class="flex align-items-center gap-2 text-sm text-color-secondary">
        <span>Version {{ document.versionCode }}</span>
        <span>·</span>
        @if (document.isFuture()) {
        <span>Entrera en vigueur le {{ document.versionDate.toDate() | date:'dd/MM/yyyy' }}</span>
        } @else {
        <span>En vigueur depuis le {{ document.versionDate.toDate() | date:'dd/MM/yyyy' }}</span>
        }
    </div>

    <!-- Contenu Markdown -->
    <div class="legal-content border-round surface-50 p-4 overflow-y-auto" style="max-height: 50vh">
        <markdown [data]="document.content"></markdown>
    </div>
    }
    }

    <!-- Actions -->
    <div class="flex justify-content-end gap-2">
        @if (isOptional && !isInfo) {
        <p-button label="Plus tard" severity="secondary" [outlined]="true" [rounded]="true" (onClick)="dismiss()">
        </p-button>
        } @else if (isInfo) {
        <p-button label="Fermer" severity="secondary" [outlined]="true" [rounded]="true" (onClick)="dismiss()">
        </p-button>
        }
        @if (canAccept && !isInfo) {
        <p-button [label]="acceptLabel" icon="pi pi-check" severity="success" [raised]="true" [rounded]="true"
            [loading]="accepting" (onClick)="accept()">
        </p-button>
        }
    </div>
</div>

}